import { render, staticRenderFns } from "./view.vue?vue&type=template&id=a384d1b4&scoped=true&"
import script from "./view.vue?vue&type=script&lang=js&"
export * from "./view.vue?vue&type=script&lang=js&"
import style0 from "./view.vue?vue&type=style&index=0&id=a384d1b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a384d1b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a384d1b4')) {
      api.createRecord('a384d1b4', component.options)
    } else {
      api.reload('a384d1b4', component.options)
    }
    module.hot.accept("./view.vue?vue&type=template&id=a384d1b4&scoped=true&", function () {
      api.rerender('a384d1b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/taskMgr/repairWorkOrderMgr/view.vue"
export default component.exports